var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { staticClass: "bg-white", attrs: { "fill-height": "", fluid: "" } },
    [
      _c(
        "v-row",
        { staticStyle: { "margin-top": "-10%" }, attrs: { justify: "center" } },
        [
          _c("v-col", { staticClass: "ta-c", attrs: { cols: "12" } }, [
            _c("img", { attrs: { src: _vm.ic_smb_welcome } }),
          ]),
          _c("v-col", { staticClass: "ta-c", attrs: { cols: "12" } }, [
            _c("label", { staticClass: "declined-lbl" }, [
              _vm._v("Your offer has been awarded and booked!"),
            ]),
          ]),
          _c("v-col", { staticClass: "ta-c", attrs: { cols: "12" } }, [
            _c("img", { attrs: { src: _vm.ic_tick_green } }),
          ]),
          _c(
            "v-col",
            {
              staticClass: "ta-c mt-n4",
              attrs: { xl: "4", lg: "4", md: "5", sm: "10", cols: "10" },
            },
            [
              _c("label", { staticClass: "bol-number" }, [
                _vm._v("Shipment BOL Number: "),
              ]),
              _c("label", { staticClass: "bol-number-value ml-1" }, [
                _vm._v(_vm._s(_vm.shipmentId)),
              ]),
              _c("img", {
                staticClass: "abs ml-2 copy mt-1",
                attrs: { src: _vm.ic_copy, title: "Copy to Clipboard" },
                on: { click: _vm.copyToClipboard },
              }),
            ]
          ),
          _c("v-col", { attrs: { cols: "12" } }),
          _c(
            "v-col",
            {
              staticClass: "ta-c mt-n12",
              attrs: { xl: "4", lg: "4", md: "5", sm: "10", cols: "10" },
            },
            [
              _c("label", { staticClass: "bol-number" }, [
                _vm._v("Order Date: " + _vm._s(_vm.date) + " "),
              ]),
            ]
          ),
          _c(
            "v-col",
            { staticClass: "ta-c", attrs: { cols: "12" } },
            [
              _c(
                "v-row",
                { attrs: { justify: "center" } },
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "auto" } },
                    [
                      _c("smart-btn", {
                        staticClass: "mt-2",
                        attrs: { bg: "white", label: "Dashboard" },
                        on: { click: _vm.back },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "auto" } },
                    [
                      _c("smart-btn", {
                        staticClass: "mt-2",
                        attrs: {
                          bg: "white",
                          label: "Download Rate Confirmation",
                        },
                        on: { click: _vm.rateConfirmation },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "auto" } },
                    [
                      _c("smart-btn", {
                        staticClass: "mt-2",
                        attrs: { bg: "white", label: "Print BOL" },
                        on: { click: _vm.openBillOfLadingPdf },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-snackbar",
        {
          model: {
            value: _vm.snackbar,
            callback: function ($$v) {
              _vm.snackbar = $$v
            },
            expression: "snackbar",
          },
        },
        [_vm._v(" " + _vm._s(_vm.snackbarText) + " ")]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }